import { AbstractControl, ValidatorFn } from '@angular/forms';
import { parseLocaleNumber } from 'src/app/utils/format-currency';

export function CurrencyInputMinimumValidator(minimum: number, locale: string): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const parsedValue = parseLocaleNumber(control.value, locale);
    const valid = parsedValue >= minimum;
    return valid ? null : { invalidCurrencyMinimum: true };
  };
}
